import React from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

import MotorPage from './MotorMainPage'

import PageNotFound from 'pages/PageNotFound'
import MotorCompare from './MotorCompare'
import MotorBuy from './MotorBuy'
// import Footer from 'components/Footer'
import PrivateRoute from 'hocs/PrivateRoute'

const MotorRoutes = props => (
  <>
    <Switch>
      <Route exact path={props.match.path} component={MotorPage} />
      <Route
        exact
        path={`${props.match.path}/compare`}
        component={MotorCompare}
      />
      <PrivateRoute path={`${props.match.path}/:id/buy`} component={MotorBuy} />
      <Route component={PageNotFound} />
    </Switch>
    {/* <Footer /> */}
  </>
)
MotorRoutes.propTypes = {
  match: PropTypes.object
}

export default MotorRoutes
